import { type FC } from "react";
import { useCreateOrderForm } from "../lib/create-order-context";
import { EmptyState, VStack } from "@chakra-ui/react";
import { LuShoppingCart } from "react-icons/lu";
import { CreateOrderLine } from "./create-order-line";

interface Props {
  isReadonly?: boolean;
}

export const CreateOrderLinesListing: FC<Props> = ({ isReadonly }) => {
  const { values } = useCreateOrderForm();

  const renderEmptyState = () => (
    <EmptyState.Root size="sm">
      <EmptyState.Content>
        <EmptyState.Indicator>
          <LuShoppingCart />
        </EmptyState.Indicator>
        <VStack textAlign="center">
          <EmptyState.Title>No items here yet</EmptyState.Title>
          <EmptyState.Description>
            Please, add some items to your order first
          </EmptyState.Description>
        </VStack>
      </EmptyState.Content>
    </EmptyState.Root>
  );

  return values?.lines?.length ? (
    <VStack w="full" gap={4}>
      {values.lines.map((line, index) => (
        <CreateOrderLine
          isReadonly={isReadonly}
          key={line.id}
          dto={line}
          index={index}
        />
      ))}
    </VStack>
  ) : (
    renderEmptyState()
  );
};
